import { gql } from '@apollo/client';

/**
 * Lean Event-view queries: same row filters as the tab queries, but no sibling
 * aggregates and no user_notes. Used only by event/venue search grouping so
 * normal Manage Tickets tabs stay unchanged.
 */

export const EVENT_VIEW_GET_MANAGE_TICKETS = gql`
query EventViewFiltermanagetickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%") {
  filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    tp_list_price
    u_id
    u_first_name
    u_last_name
    tp_validity_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    full_name
    u_email_id
    u_original_email
    e_brand_name
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
    }
  }
}
`;

export const EVENT_VIEW_GET_LIST_TICKETS = gql`
query EventViewFilterlisttickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%") {
  filterlisttickets(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null},
    where: {
      tp_status: { _eq: "List" },
      tp_is_published: { _eq: true },
      u_pricing_mode: { _ilike: $pricingMode }
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]}
      ]
    },
    limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
    }
  }
}
`;

export const EVENT_VIEW_GET_SOLD_TICKETS = gql`
query EventViewFilterSoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $paymentStatus: String, $payoutType: String = null, $pricingMode: String = "%") {
  FilterSoldTickets: filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_logitix_amount
    tp_sold_amount
    tp_payment_status
    tp_list_price
    tp_quick_cut_amount
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_payout_status
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    ticket_user {
      u_sales_reps_id
      sales_reps {
        sr_commission_rate
        sr_first_name
        sr_last_name
      }
    }
    user {
      u_role
    }
  }
}
`;

export const EVENT_VIEW_GET_DELIST_AND_RETURN_TICKETS = gql`
query EventViewFilterreturntickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%", $delistedStatuses: [String!]! = ["Delist", "DelistInProgress", "DelistRequested", "Return"]) {
  filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:$delistedStatuses},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
    }
  }
}
`;

export const EVENT_VIEW_GET_LISTING_REQUEST_CANCELLED_TICKETS = gql`
query EventViewFilterListingRequestCancelledTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%") {
  filterListingRequestCancelledTickets: filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    user {
      u_role
    }
  }
}
`;

export const EVENT_VIEW_GET_DELETED_TICKETS = gql`
query EventViewFilterDeletedTickets (
  $enddate: timestamptz,
  $startdate: timestamptz,
  $pageSize: Int,
  $pageOffset: Int,
  $order_by: [ticket_placement_order_by!],
  $search_event: String = "%",
  $search_client: String = "%",
  $array_tpid: jsonb,
  $pricingMode: String = "%"
) {
  ticket_placement(
    where: {
      _and: [
        { tp_status: { _eq: Deleted } },
        { ticket: { event: { e_date: { _gte: $startdate } } } },
        { ticket: { event: { e_date: { _lte: $enddate } } } },
        { ticket: { event: { e_name: { _ilike: $search_event } } } },
        { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
        { ticket: { user: { u_pricing_mode: { _ilike: $pricingMode } } } }
      ]
    }
    limit: $pageSize
    offset: $pageOffset
    order_by: $order_by
  ) {
    tp_id
    tp_section
    tp_row
    tp_seat_no
    tp_list_price
    tp_status
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    ticket {
      t_id
      e_id: event { e_id }
      event {
        e_id
        e_name
        e_address
        e_date
        e_brand_name
        e_status
        e_time_zone
        e_date_time_zone
        l_id
      }
      user {
        u_id
        u_first_name
        u_last_name
        u_full_name
        u_email_id
        u_original_email
        u_pricing_mode
      }
    }
  }
}
`;
